module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', [_c('v-ons-splitter', [_c('v-ons-splitter-side', {
    staticClass: "splitter",
    attrs: {
      "width": "480px",
      "collapse": "",
      "side": "left",
      "open": _vm.isShowMenu
    },
    on: {
      "update:open": function($event) {
        _vm.isShowMenu = $event
      }
    }
  }, [_c('home-menu')], 1), _vm._v(" "), _c('v-ons-splitter-content', [_c('home-index')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57828be6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/splitter.vue
// module id = 850
// module chunks = 0